import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './useDataObjectFormLabelTranslation.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'classifier-form-label'
);
addTranslations(translations);

export const useDataObjectFormLabelTranslation = useTranslation;
